export default "__VITE_ASSET__D7OMt2d$__"